import React from "react";
import { useSelector } from "react-redux";
import { IoMdHome } from "react-icons/io";
import { SiYoutubeshorts } from "react-icons/si";
import { BiSolidVideos } from "react-icons/bi";
import { SiYoutubemusic } from "react-icons/si";
import { PiUserSquare } from "react-icons/pi";
import { MdOutlineWatchLater } from "react-icons/md";
import { MdOutlineHistory } from "react-icons/md";
import { RiDownloadLine } from "react-icons/ri";
import { AiOutlineFire } from "react-icons/ai";
import { Link } from "react-router-dom";
import { IoMusicalNoteOutline } from "react-icons/io5";
import { MdOutlineMovie } from "react-icons/md";
import { CgMediaLive } from "react-icons/cg";

const Sidebar = () => {
  const isMenuOpen = useSelector((store) => store.app.isMenuOpen);
  if (!isMenuOpen) return null;
  // return (
  //   <div className="p-5 shadow-lg ">
  //     <ul>
  //       <li className="text-xs mb-4 text-center  cursor-pointer hover:bg-gray-100 rounded-lg">
  //         <IoMdHome className="mx-auto" size={28} />
  //         home
  //       </li>
  //       <li className="text-xs mb-4 text-center cursor-pointer hover:bg-gray-100 rounded-lg">
  //         <SiYoutubeshorts className="mx-auto" size={24} />
  //         Shorts
  //       </li>
  //       <li className="text-xs mb-4 text-center cursor-pointer hover:bg-gray-100 rounded-lg">
  //         <BiSolidVideos className="mx-auto" size={24} />
  //         Subscriptions
  //       </li>
  //       <li className="text-xs mb-4 text-center cursor-pointer hover:bg-gray-100 rounded-lg">
  //         <SiYoutubemusic className="mx-auto" size={24} />
  //         YouTube music
  //       </li>
  //     </ul>
  //   </div>
  // );
  return (
    <div className="px-5 fixed  w-48 mt-16  bg-white h-screen hidden md:inline-block">
      <ul>
        <Link to="/">
          <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2  hover:bg-gray-200">
            <IoMdHome className="mr-2" size={24} />
            <span className="flex items-center">home</span>
          </div>
        </Link>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <SiYoutubeshorts className="mr-2" size={24} />
          <span className="flex items-center">Shorts</span>
        </div>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <BiSolidVideos className="mr-2" size={24} />
          <span className="flex items-center">Subscriptions</span>
        </div>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <SiYoutubemusic className="mr-2" size={24} />
          <span className="flex items-center">YouTube music</span>
        </div>
      </ul>
      <h1 className="font-bold pt-5">You</h1>
      <ul>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <PiUserSquare className="mr-2" size={24} />
          <span className="flex items-center">Your Channel</span>
        </div>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <MdOutlineWatchLater className="mr-2" size={24} />
          <span className="flex items-center">Watch later</span>
        </div>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <RiDownloadLine className="mr-2" size={24} />
          <span className="flex items-center">Downloads</span>
        </div>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <MdOutlineHistory className="mr-2" size={24} />
          <span className="flex items-center">History</span>
        </div>
      </ul>
      <h1 className="font-bold pt-5">Explore</h1>
      <ul>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <AiOutlineFire className="mr-2" size={24} />
          <span className="flex items-center">Trending</span>
        </div>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <IoMusicalNoteOutline className="mr-2" size={24} />
          <span className="flex items-center">Music</span>
        </div>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <MdOutlineMovie className="mr-2" size={24} />
          <span className="flex items-center">Movies & TV</span>
        </div>
        <div className="flex text-xs p-2 rounded-lg w-auto cursor-pointer my-2 hover:bg-gray-200">
          <CgMediaLive className="mr-2" size={24} />
          <span className="flex items-center">Live</span>
        </div>
      </ul>
    </div>
  );
};

export default Sidebar;
